import { TextLink } from '@mosey/components/navigation/TextLink';
import { useIsStandaloneRoute, useTaskSourceQuestion } from '../../utils/hooks';
import { TaskActions } from '../../common/TaskActions';
import { NextButton } from '../../common/NextButton';
import { AnsweredField } from './AnsweredField';
import { useIsPlatformUser, usePlatform } from '../../../../hooks/useUser';

export const TaskQuestionAnswered = () => {
  const isPlatformUser = useIsPlatformUser();
  const platform = usePlatform();
  const isStandaloneRoute = useIsStandaloneRoute();
  const source = useTaskSourceQuestion();
  const { form, description } = source;

  return (
    <>
      <div className="mt-4 flex flex-col gap-y-4">
        {description && <p className="max-w-3xl">{description}</p>}

        <div className="space-y-8">
          <div className="flex flex-col gap-y-6 @container/answered-fields">
            {form.sections.map((section) => {
              return section.form_fields.map((field) => {
                return <AnsweredField key={field.name} field={field} />;
              });
            })}
          </div>

          <p>
            If you need to update this answer, please{' '}
            <TextLink to="mailto:support@mosey.com" target="_blank">
              contact support
            </TextLink>
            .
          </p>
        </div>
      </div>

      <TaskActions>
        <NextButton defaultToHome>
          {isStandaloneRoute && isPlatformUser && platform
            ? `Return to ${platform.name}`
            : isStandaloneRoute
              ? 'Finish'
              : 'Next'}
        </NextButton>
      </TaskActions>
    </>
  );
};
